import './index.styl';
import template from './index.jst';
import TradePlayerPool from '../../Fantasy/Trades/TradePlayerPool';
import StatsCentrePlayerPoolList from '../StatsCentrePlayerPoolList';
import StatsCentrePlayerPoolFilters from '../StatsCentrePlayerPoolFilters';

export class StatsCentrePlayerPool extends TradePlayerPool {
	get template(){
		return template;
	}

	get className(){
		return 'trade-pool-list stats-centre-page';
	}

	initialize(){
		this.getRegion('filters').show(new StatsCentrePlayerPoolFilters());
		this.getRegion('list').show(new StatsCentrePlayerPoolList());
	}
}